import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "safe-container" }
const _hoisted_2 = { class: "safe-box" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "safe-box-content" }

import { ref, computed } from "vue";
import { IonModal } from "@ionic/vue";
import { useToggle } from "@vueuse/core";
import { getBrandImageUrl } from "@/js/brandImages";


export default /*@__PURE__*/_defineComponent({
  __name: 'SafeWord',
  props: {
    msg: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const [isOpen, changeIsOpen] = useToggle(true);
const safaModalRef = ref();
const wordMsg = computed(() => {
  const wordMatch = props.msg.match(/\[(.+)]/);
  const wordList = wordMatch ? wordMatch[1].split(",") : [];
  const wordResult = wordList.map((word) => word.replace(/(?<=\w)\w(?=\w)/g, "*")).join(",");
  return `【${wordResult}】`;
});
function closeTip() {
  changeIsOpen(false);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonModal), {
    id: "safe-modal",
    ref_key: "safaModalRef",
    ref: safaModalRef,
    "is-open": _unref(isOpen),
    onDidDismiss: closeTip
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "safe-box-img",
            src: _unref(getBrandImageUrl)('ai_smart_reading/safe_img.png'),
            alt: ""
          }, null, 8, _hoisted_3),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "safe-box-title" }, "检测到敏感词汇！！", -1)),
          _createElementVNode("div", _hoisted_4, _toDisplayString(wordMsg.value) + "是不文明且不适合在正式场合使用的词汇哦。我们应该倡导文明用语，保持良好的交流氛围呢。 ", 1),
          _createElementVNode("div", {
            class: "safe-box-button",
            onClick: closeTip
          }, "知道了")
        ])
      ])
    ]),
    _: 1
  }, 8, ["is-open"]))
}
}

})